import React from "react";
import Slider from "../../../Common/Slider";
import Loading from "../../../Common/Loading";
import { Color } from "../../../../Utils/styles";
import { BsArrowLeftShort } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
function TwoSliders({ landingLoading }) {
  if (landingLoading) {
    return (
      <section className="background-gray pb-3 pt-1">
        <div className="container">
          <div className="row">
            <Loading count={2} col={6} height={"520"} />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="background-gray pb-3 pt-1">
      <div className="container">
        <div className="row">
          <div className="col-md-6 mt-2">
            <Slider
              arr={[
                {
                  url: "/img/slider/moj.png",
                  component: data => {
                    return <RenderTitle data={data} />;
                  },
                  item: {
                    name: "استخر موج شاهرود",
                    slug: "استخر-موج-شاهرود",
                    pool: true,
                    route: "/pool/shahrud/استخر-موج-شاهرود",
                  },
                },
                {
                  url: "/img/slider/kosar.png",
                  component: data => {
                    return <RenderTitle data={data} />;
                  },
                  item: {
                    name: "استخر مجموعه کوثر",
                    slug: "استخر-مجموعه-کوثر",
                    pool: true,
                    route: "/pool/mashhad/استخر-مجموعه-کوثر",
                  },
                },
                {
                  url: "/img/slider/amiran.png",
                  component: data => {
                    return <RenderTitle data={data} />;
                  },
                  item: {
                    name: "استخر هتل امیران",
                    slug: "استخر-هتل-امیران-نیشابور",
                    pool: true,
                    route: "/pool/neyshabur/استخر-هتل-امیران-نیشابور",
                  },
                },
              ]}
              imageStyle={{
                height: window.innerWidth > 447 ? "250px" : "180px",
                width: "100%",
                borderRadius: "10px",
                objectFit: "cover",
              }}
              link={true}
            />
          </div>
          <div className="col-md-6 mt-2">
            <Slider
              arr={[
                {
                  url: "/img/slider/helal.png",
                  component: data => {
                    return <RenderTitle data={data} />;
                  },
                  item: {
                    name: "سالن هلال احمر",
                    slug: "سالن-هلال-احمر",
                    pool: false,
                    route: "/salon/shahrud/سالن-هلال-احمر",
                  },
                },
                {
                  url: "/img/slider/kar.png",
                  component: data => {
                    return <RenderTitle data={data} />;
                  },
                  item: {
                    name: "سالن کارگران",
                    slug: "سالن-کارگران-نیشابور",
                    pool: false,
                    route: "/salon/neyshabur/سالن-کارگران-نیشابور",
                  },
                },
                {
                  url: "/img/slider/akbari.png",
                  component: data => {
                    return <RenderTitle data={data} />;
                  },
                  item: {
                    name: "سالن شهید اکبری",
                    slug: "سالن-شهید-اکبری-2",
                    pool: false,
                    route: "/salon/shahrud/سالن-شهید-اکبری-2",
                  },
                },
              ]}
              imageStyle={{
                height: window.innerWidth > 447 ? "250px" : "180px",
                width: "100%",
                borderRadius: "15px",
                objectFit: "cover",
              }}
              link={true}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default TwoSliders;
const RenderTitle = ({ data }) => {
  const navigate = useNavigate();
  let color = Color.yellow;
  if (data.item.pool) {
    color = Color.blueSlider;
  }
  return (
    <div
      style={{
        position: "absolute",
        margin: "10px",
        top: window.innerWidth > 447 ? "40px" : "10px",
        width: window.innerWidth > 447 ? "260px" : "200px",
      }}
    >
      <div
        style={{
          backgroundColor: "rgba(0,0,0,0.8)",
          borderRadius: "5px",
          bottom: "20px",
          padding: "10px",
        }}
      >
        <h6
          // rgb(2, 138, 26)
          style={{
            color: color,
            fontWeight: "500",
            fontSize: window.innerWidth > 447 ? "24px" : "20px",
            margin: 0,
            padding: 0,
          }}
        >
          {data.item && data.item.name}
        </h6>
        <p
          style={{
            color: Color.white,
            fontWeight: "400",
            fontSize: window.innerWidth > 447 ? "16px" : "12px",
            margin: 0,
            padding: 0,
          }}
        >
          ! تجربه رزرو آنلاین فقط با یک کلیک
        </p>
      </div>

      <Link
        style={{
          // borderRadius: "5px",
          marginTop: "40px",
          bottom: "10px",
          backgroundColor: color,
          width: "60%",
          marginLeft: "auto",
          display: "flex",
          flexDirection: "row-reverse",
          borderRadius: "7px",
          overflow: "hidden",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
        }}
        to={`${data.item.route}`}
      >
        <span
          style={{
            color: color,
            height: "100%",
            backgroundColor: Color.white,
            padding: "5px 22px",
            borderRadius: "5px",
            fontSize: window.innerWidth > 447 ? "13px" : "9px",
            fontWeight: "400",
          }}
        >
          مشاهده و رزرو
        </span>
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <BsArrowLeftShort size={"1.5rem"} color={Color.white} />
        </div>
      </Link>
    </div>
  );
};
